import { z } from 'zod';
import { assertUnreachable } from '../../../../react-commons/utils/utilFunctions';

export enum ApplicationVersion {
    V_0_8_0 = 'V_0_8_0',
    V_0_9_7 = 'V_0_9_7',
    V_0_9_8 = 'V_0_9_8',
}

export const ApplicationVersionSchema = z.enum(ApplicationVersion);

export const formatMaestraSignalVersion = (value: ApplicationVersion) => {
    switch (value) {
        case ApplicationVersion.V_0_8_0:
            return '0.8.0';
        case ApplicationVersion.V_0_9_7:
            return '0.9.7';
        case ApplicationVersion.V_0_9_8:
            return '0.9.8';
        default:
            return assertUnreachable(value);
    }
};
